export default "__VITE_PUBLIC_ASSET__611c8b23__"